<health-statistic-card
    [healthTypePath]="healthTypePath"
    [title]="title"
    [value]="lastMonitoredData"
    [dataType]="dataType"
    [period]="period"
    [isLoading]="isLoading"
    [iconPath]="'../../../assets/img/monitoring/heart.png'">
</health-statistic-card>
